import * as types from '../actions/types';

export const initialState = {
  version: 0
};

export default (state = initialState, action) => {
  switch (action.type) {
    case types.CHANGE_VARIATIONS_VERSION:
      return {
        ...state,
        version: state.version + 1
      };
    default:
      return state;
  }
};
